// extracted by mini-css-extract-plugin
export default {"text":"styles_text__+fyfk","heading":"styles_heading__eo+pu","slanted":"styles_slanted__UhNDD","textContainer":"styles_textContainer__Eoslh"};